import React, { useState } from "react";
import ShowToast from "components/ShowToast";
import { useSession } from "hooks/useSession";
import { fetchWrapper } from "utils/apiFetch";

// Mirrors Flutter `MakePaymentDialog` / `_MakePaymentDialogState`:
// POST soft_payout_transaction {
//   transection_mode, userid, account_number, ifsc_code,
//   holder_name, bank_name, remark, amount, lat, long
// }
const MakeWalletPaymentModal = ({ show, onClose, userData, onSuccess }) => {
  const { userid } = useSession();

  const [amount, setAmount] = useState("");
  const [remark, setRemark] = useState("");
  const [transectionMode, setTransectionMode] = useState("IMPS");
  const [processing, setProcessing] = useState(false);

  if (!show) return null;

  const handlePayment = async (e) => {
    e.preventDefault();

    if (!amount || !remark) {
      ShowToast("Enter amount and remark", "danger");
      return;
    }

    setProcessing(true);
    try {
      const formData = new FormData();
      formData.append("transection_mode", transectionMode);
      formData.append("userid", userid);
      formData.append("account_number", userData.account);
      formData.append("ifsc_code", userData.IFSC_Code);
      formData.append("holder_name", userData.name);
      formData.append("bank_name", userData.Bank_Name);
      formData.append("remark", remark);
      formData.append("amount", amount);
      // Same fixed coordinates used in the Flutter implementation.
      formData.append("lat", "26.0846");
      formData.append("long", "80.9248");

      const res = await fetchWrapper("https://pro.mokshiq.in/soft_payout_transaction", {
        method: "POST",
        body: formData,
      });

      if (res?.status === true) {
        ShowToast(res.message || "Transfer Successful", "success");
        setAmount("");
        setRemark("");
        onSuccess && onSuccess(res.reference_num);
      } else {
        ShowToast(res?.message || "Transfer Failed", "danger");
      }
    } catch (e) {
      ShowToast("Something went wrong while processing the transaction", "danger");
    } finally {
      setProcessing(false);
    }
  };

  return (
    <div className="modal-backdrop-custom">
      <div className="modal-box">
        <div className="modal-header-custom">
          <h5>Make Transaction</h5>
          {!processing && (
            <button className="close-btn" onClick={onClose}>
              &times;
            </button>
          )}
        </div>

        {processing ? (
          <div className="processing-state">
            <div className="loader" />
            <p>Please wait while transaction is processed!..</p>
          </div>
        ) : (
          <form onSubmit={handlePayment}>
            <div className="form-group">
              <label>Amount</label>
              <input
                type="number"
                className="form-control"
                value={amount}
                onChange={(e) => setAmount(e.target.value)}
                placeholder="Enter Amount"
                maxLength={10}
              />
            </div>

            <div className="form-group">
              <label>Transaction Type</label>
              <select
                className="form-control"
                value={transectionMode}
                onChange={(e) => setTransectionMode(e.target.value)}
              >
                <option value="IMPS">IMPS</option>
                <option value="NEFT">NEFT</option>
              </select>
            </div>

            <div className="form-group">
              <label>Remark</label>
              <input
                type="text"
                className="form-control"
                value={remark}
                onChange={(e) => setRemark(e.target.value)}
                placeholder="Enter Remark"
                maxLength={500}
              />
            </div>

            <div className="modal-footer-custom">
              <button type="button" className="btn secondary" onClick={onClose}>
                Close
              </button>
              <button type="submit" className="btn primary">
                Make Payment
              </button>
            </div>
          </form>
        )}
      </div>
    </div>
  );
};

export default MakeWalletPaymentModal;